module.exports = __webpack_public_path__ + "static/media/PALOSANTO_06.3184f9d8.png";